import { initReactI18next } from 'react-i18next';

import en from '../../locales/en.json';
import th from '../../locales/th.json';

import i18n from 'i18next';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    th: { translation: th },
  },
  lng: 'en',
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: [],
  },
  load: 'languageOnly',
});

export default i18n;
